import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import {
  LayoutDashboard,
  Users,
  UserPlus,
  MapPin,
  FileText,
  DollarSign,
  Settings,
  LogOutIcon,
  Menu,
  MessageCircleMore,
  X,
  Info,
  CreditCard,
  Building2,
  UserCheck,
  Clock,
  Heart,
  Shield,
  Layers,
  BarChart3,
  TrendingUp,
  Database,
  AlertTriangle,
  DatabaseZap,
  PieChart,
  Wrench,
  Bot,
  BrainCircuit,
  ChevronDown,
  Calendar,
  Zap,
  UserX,
  BookOpen,
  Tag,
  GitCompare,
  ShieldAlert,
  Activity,
  FileImage,
  FileSpreadsheet,
  Smartphone,
} from "lucide-react";
import { FaDocker, FaGooglePlay } from "react-icons/fa6";
import { FaWhatsapp } from "react-icons/fa";
import { useAuth } from "./features/AuthContext";
import { localStoreObjects } from "../utilities/util";
import { useWhatsapp } from "./Whatsapp/WhatsappContext";

const DOCKER_PORTAL_URL =
  "https://docker.prod.smartmatrimony.ai?e=bhutramohit@gmail.com&ps=Miisco@45*JLSksS";

const normalizeRole = (role) => {
  const lowered = (role || "").toLowerCase();
  if (["customer_support", "customer_lead", "calling_team_lead"].includes(lowered)) {
    return "support";
  }
  return lowered;
};

export default function SideBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(true);
  const [openGroups, setOpenGroups] = useState({ logsStats: true });
  const [collapsedPicker, setCollapsedPicker] = useState({
    open: false,
    label: "",
    children: [],
    top: 0,
  });
  const pickerRef = useRef(null);
  const { isAuthenticated, logout } = useAuth();
  const { totalUnreadCount } = useWhatsapp();

  let Role = null;
  let rawRole = "";
  const data = localStorage.getItem("data");
  if (data) {
    try {
      const parsed = JSON.parse(data);
      rawRole = (parsed.Role || "").toLowerCase();
      Role = normalizeRole(parsed.Role || null);
    } catch (error) {
      console.error("Failed to parse localStorage data", error);
    }
  }

  const allNavItems = [
    {
      label: "Dashboard",
      to: "/dashboard",
      icon: LayoutDashboard,
      roles: ["admin", "support", "calling_team_lead", "super_admin"],
    },
    {
      label: "Users",
      to: "/users",
      icon: Users,
      roles: ["admin", "support", "calling_team_lead", "super_admin"],
    },
    {
      label: "Special Preferences",
      to: "/special-preference-users",
      icon: Heart,
      roles: ["admin", "support", "calling_team_lead", "super_admin"],
    },
    {
      label: "Matches",
      to: "/matches",
      icon: Layers,
      roles: ["admin", "support", "calling_team_lead", "super_admin"],
    },
    {
      label: "Hot Leads",
      to: "/hot-leads",
      icon: Heart,
      roles: ["admin", "support", "calling_team_lead", "super_admin"],
    },
    {
      label: "Team Action Queue",
      to: "/team-action-queue",
      icon: Activity,
      roles: ["admin", "support", "calling_team_lead", "super_admin"],
    },
    {
      label: "New Users",
      to: "/new-users",
      icon: UserPlus,
      roles: ["admin", "super_admin"],
    },
    {
      label: "State & City Analytics",
      to: "/state-city-analytics",
      icon: MapPin,
      roles: ["admin", "support", "super_admin"],
      exactRoles: ["admin", "support", "super_admin"],
    },
    {
      label: "Whatsapp",
      to: "/whatsapp",
      icon: MessageCircleMore,
      roles: ["admin", "support", "calling_team_lead", "super_admin"],
    },
    {
      label: "Sales-Team Dashboard",
      to: "/sales-team-dashboard",
      icon: TrendingUp,
      roles: ["admin", "support", "calling_team_lead", "super_admin"],
    },
    {
      label: "Team Activity",
      to: "/team-activity",
      icon: Activity,
      roles: ["admin", "support", "calling_team_lead", "super_admin"],
    },
    {
      label: "Transactions",
      to: "/transactions",
      icon: CreditCard,
      roles: ["admin", "support", "calling_team_lead", "super_admin"],
    },
    {
      label: "Admin Services",
      to: "/admin-services",
      icon: Wrench,
      roles: ["admin", "super_admin"],
    },
    {
      label: "Members Overview",
      to: "/members-overview",
      icon: UserCheck,
      roles: ["admin", "support", "calling_team_lead", "super_admin"],
    },
    {
      label: "No Matches Today",
      to: "/users-without-matches-today",
      icon: UserX,
      roles: ["admin", "support", "calling_team_lead", "super_admin"],
    },
    {
      label: "Whatsapp Templates",
      to: "/whatsapp-templates",
      icon: FileText,
      roles: ["admin", "support", "calling_team_lead", "super_admin"],
    },
    {
      label: "Whatsapp Groups",
      icon: FaWhatsapp,
      key: "whatsappStats",
      roles: ["admin", "super_admin"],
      children: [
        {
          label: "SMM Interested",
          to: "/whatsapp-biodata-media",
          icon: FileImage,
          roles: ["admin", "super_admin"],
        },
        {
          label: "Onboarding SMM",
          to: "/onboarding-smm-export",
          icon: FileSpreadsheet,
          roles: ["admin", "super_admin"],
        },
        {
          label: "Biodata New Users",
          to: "/biodata-non-user-export",
          icon: FileSpreadsheet,
          roles: ["admin", "super_admin"],
        },
      ],
    },
    {
      label: "Google Overview",
      to: "/google-overview",
      icon: BarChart3,
      roles: ["admin", "super_admin"],
    },
    {
      label: "App & Devices",
      to: "/app-analytics",
      icon: Smartphone,
      roles: ["admin", "super_admin"],
    },
    // {
    //   label: "Google Play Console",
    //   to: "/google-play-console",
    //   icon: FaGooglePlay,
    //   roles: ["admin", "super_admin"],
    // },
    {
      label: "Subscriptions",
      to: "/subscriptions",
      icon: DollarSign,
      roles: ["admin", "super_admin"],
    },
    {
      label: "Coupons",
      to: "/coupons",
      icon: Tag,
      roles: ["admin", "support", "calling_team_lead", "super_admin"],
    },
    {
      label: "Match Pair Compare",
      to: "/match-pair",
      icon: GitCompare,
      roles: ["admin", "support", "calling_team_lead", "super_admin"],
    },
    {
      label: "Match Data Checks",
      to: "/match-data-checks",
      icon: ShieldAlert,
      roles: ["admin", "super_admin"],
    },
    {
      label: "Dropdown Data",
      to: "/dropdown-data",
      icon: PieChart,
      roles: ["admin", "super_admin"],
    },
    {
      label: "Logs / Stats",
      icon: Database,
      key: "logsStats",
      roles: ["admin", "super_admin"],
      children: [
        {
          label: "API Logs",
          to: "/api-logs",
          icon: FileText,
          roles: ["admin", "super_admin"],
        },
        {
          label: "Error Logs",
          to: "/error-logs",
          icon: AlertTriangle,
          roles: ["admin", "super_admin"],
        },
        {
          label: "Admin Logs",
          to: "/admin-logs",
          icon: FileText,
          roles: ["admin", "super_admin"],
        },
        {
          label: "Service Logs",
          to: "/service-logs",
          icon: Zap,
          roles: ["admin", "super_admin"],
        },
        {
          label: "LLM Logs",
          to: "/llm-logs",
          icon: BrainCircuit,
          roles: ["admin", "super_admin"],
        },
        {
          label: "PostgreSQL",
          to: "/postgres",
          icon: DatabaseZap,
          roles: ["admin", "super_admin"],
        },
        {
          label: "Cache Admin",
          to: "/cache-admin",
          icon: Database,
          roles: ["admin", "super_admin"],
        },
        {
          label: "User Update values",
          to: "/user-update-values",
          icon: FileText,
          roles: ["admin", "super_admin"],
        },
      ],
    },
    {
      label: "Unregistered-Users",
      to: "/employees",
      icon: Building2,
      roles: ["admin", "super_admin"],
    },

    {
      label: "Documents",
      to: "/documents",
      icon: BookOpen,
      roles: ["admin", "subadmin", "moderator", "super_admin"],
    },
    // {
    //   label: "Settings",
    //   to: "/settings",
    //   icon: Settings,
    //   roles: ["admin", "super_admin"],
    // },
    {
      label: "Version",
      to: "/version",
      icon: Info,
      roles: ["admin", "support", "calling_team_lead", "super_admin"],
    },
    {
      label: "Employee Attendance",
      to: "/employee-attendance",
      icon: Clock,
      roles: ["admin", "super_admin"],
    },
    {
      label: "Interested Users",
      to: "/interested-users",
      icon: Heart,
      roles: ["admin", "support", "calling_team_lead", "super_admin"],
    },
    {
      label: "Manage Admins",
      to: "/manage-admins",
      icon: Shield,
      roles: ["super_admin"], // Only for SUPER_ADMIN
    },
    {
      label: "Marketing Stats",
      to: "/marketing-stats",
      icon: BarChart3,
      roles: ["super_admin"], // Only for SUPER_ADMIN
    },
    {
      label: "AI Agent",
      to: "/ai-agent",
      icon: Bot,
      roles: ["admin", "support", "calling_team_lead", "super_admin"],
    },
    {
      label: "Events Management",
      to: "/events-management",
      icon: Calendar,
      roles: ["admin", "support", "calling_team_lead", "super_admin"],
    },
    {
      label: "Docker Portal",
      icon: FaDocker,
      roles: ["admin", "super_admin"],
      externalUrl: DOCKER_PORTAL_URL,
    },

    {
      label: "Logout",
      to: "/login",
      icon: LogOutIcon,
      roles: ["admin", "support", "calling_team_lead", "super_admin"],
      onClick: () => {
        localStorage.removeItem(localStoreObjects.userId);
        logout();
      },
    },
  ];

  const navItems = allNavItems
    .map((item) => {
      if (!item.children) return item;
      const children = item.children.filter((c) =>
        c.roles.includes(Role),
      );
      return { ...item, children };
    })
    .filter(
      (item) =>
        item.roles.includes(Role) &&
        (!item.exactRoles || item.exactRoles.includes(rawRole)) &&
        (!item.children || item.children.length > 0),
    );

  // useEffect must be called before any early returns
  useEffect(() => {
    if (navItems.length === 0 && isAuthenticated) {
      logout();
    }
  }, [navItems.length, isAuthenticated, logout]);

  useEffect(() => {
    if (!collapsed) {
      setCollapsedPicker({ open: false, label: "", children: [], top: 0 });
    }
  }, [collapsed]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        collapsedPicker.open &&
        pickerRef.current &&
        !pickerRef.current.contains(event.target) &&
        !event.target.closest(".sidebar-dropdown-trigger")
      ) {
        setCollapsedPicker({ open: false, label: "", children: [], top: 0 });
      }
    };

    const handleScrollOrResize = () => {
      if (collapsedPicker.open) {
        setCollapsedPicker({ open: false, label: "", children: [], top: 0 });
      }
    };

    if (collapsedPicker.open) {
      document.addEventListener("mousedown", handleOutsideClick);
      window.addEventListener("scroll", handleScrollOrResize, true);
      window.addEventListener("resize", handleScrollOrResize);
    }
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      window.removeEventListener("scroll", handleScrollOrResize, true);
      window.removeEventListener("resize", handleScrollOrResize);
    };
  }, [collapsedPicker.open]);

  // Early return AFTER all hooks
  if (!isAuthenticated) return null;

  return (
    <aside
      className={`relative sticky top-0 z-20 h-screen overflow-hidden border-r border-slate-800 bg-slate-950 transition-[width] duration-300 ease-in-out ${collapsed ? "w-16" : "w-64"
        } flex flex-col`}
    >
      <div
        className={`flex h-16 flex-shrink-0 items-center border-b border-slate-800 transition-all duration-300 ${collapsed ? "justify-center" : "px-6 justify-between"
          }`}
      >
        <div
          className={`text-lg font-bold text-white tracking-wide whitespace-nowrap overflow-hidden transition-opacity duration-300 ${collapsed ? "opacity-0 w-0" : "opacity-100 w-auto"
            }`}
        >
          💍 Matrimony
        </div>
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="text-slate-400 hover:text-white p-1 rounded transition-colors"
          title={collapsed ? "Expand" : "Collapse"}
        >
          {collapsed ? <Menu size={20} /> : <X size={20} />}
        </button>
      </div>

      {collapsed && collapsedPicker.open && (
        <div
          ref={pickerRef}
          style={{
            position: "fixed",
            top: `${collapsedPicker.top}px`,
            left: "64px",
          }}
          className="z-50 w-56 rounded-xl border border-slate-700 bg-slate-900 shadow-2xl p-2 animate-in fade-in zoom-in-95 duration-100"
        >
          <div className="px-2 py-1 text-[10px] uppercase tracking-wider text-slate-400 font-bold">
            {collapsedPicker.label}
          </div>
          <div className="space-y-1">
            {collapsedPicker.children.map((child) => {
              const ChildIcon = child.icon;
              const isActive = location.pathname === child.to;
              return (
                <button
                  key={child.label}
                  type="button"
                  onClick={() => {
                    navigate(child.to);
                    setCollapsedPicker({
                      open: false,
                      label: "",
                      children: [],
                      top: 0,
                    });
                  }}
                  className={`w-full flex items-center gap-2 rounded-lg px-2 py-2 text-left text-sm transition ${isActive
                    ? "bg-slate-800 text-white"
                    : "text-slate-300 hover:bg-slate-800 hover:text-white"
                    }`}
                >
                  <ChildIcon size={14} />
                  <span>{child.label}</span>
                </button>
              );
            })}
          </div>
        </div>
      )}

      <nav
        className={`min-h-0 flex-1 space-y-1 overflow-y-auto py-4 ${collapsed ? "px-2" : "px-3"
          }`}
      >
        {navItems.map((item) => {
          const {
            label,
            to,
            icon: Icon,
            onClick,
            children,
            key,
            externalUrl,
          } = item;

          if (children?.length) {
            const groupActive = children.some(
              (c) => location.pathname === c.to,
            );
            const isOpen = !!openGroups[key || label];
            return (
              <div key={label} className="space-y-1">
                <button
                  type="button"
                  className={`sidebar-dropdown-trigger w-full flex items-center rounded-md transition-all duration-200 whitespace-nowrap overflow-hidden group relative ${groupActive
                    ? "text-white bg-slate-800"
                    : "text-slate-400 hover:bg-slate-900 hover:text-white"
                    } ${collapsed ? "w-10 h-10 justify-center mx-auto" : "gap-3 py-2 px-3 justify-between"}`}
                  onClick={(e) => {
                    if (collapsed) {
                      const rect = e.currentTarget.getBoundingClientRect();
                      // Auto-shift top coordinate if it would overflow bottom viewport
                      const popupEstimatedHeight = (children?.length || 0) * 36 + 40;
                      const calculatedTop = rect.top + popupEstimatedHeight > window.innerHeight
                        ? Math.max(10, window.innerHeight - popupEstimatedHeight - 10)
                        : rect.top;

                      setCollapsedPicker((prev) => ({
                        open: !(prev.open && prev.label === label),
                        label,
                        children,
                        top: calculatedTop,
                      }));
                      return;
                    }
                    setOpenGroups((prev) => ({
                      ...prev,
                      [key || label]: !isOpen,
                    }));
                  }}
                  title={collapsed ? label : ""}
                >
                  <div className="flex items-center gap-3">
                    <Icon
                      size={collapsed ? 20 : 18}
                      className="transition-transform duration-200"
                    />
                    {!collapsed && (
                      <span className="text-sm font-medium">{label}</span>
                    )}
                  </div>
                  {!collapsed && (
                    <ChevronDown
                      size={16}
                      className={`transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`}
                    />
                  )}
                </button>

                {!collapsed && isOpen && (
                  <div className="ml-5 space-y-1 border-l border-slate-800 pl-3">
                    {children.map((child) => {
                      const ChildIcon = child.icon;
                      return (
                        <NavLink
                          key={child.label}
                          to={child.to}
                          className={({ isActive }) =>
                            `flex items-center gap-2 rounded-md transition-all duration-200 py-2 px-2 text-sm ${isActive
                              ? "text-white bg-slate-800"
                              : "text-slate-400 hover:bg-slate-900 hover:text-white"
                            }`
                          }
                        >
                          <ChildIcon size={14} />
                          <span>{child.label}</span>
                        </NavLink>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          }

          if (externalUrl) {
            return (
              <button
                key={label}
                type="button"
                className={`flex w-full items-center rounded-md transition-all duration-200 whitespace-nowrap overflow-hidden group relative text-slate-400 hover:bg-slate-900 hover:text-white ${collapsed
                  ? "w-10 h-10 justify-center mx-auto"
                  : "gap-3 py-2 px-3"
                  }`}
                onClick={() => {
                  setCollapsedPicker({ open: false, label: "", children: [], top: 0 });
                  window.open(externalUrl, "_blank", "noopener,noreferrer");
                }}
                title={collapsed ? label : ""}
              >
                <div className="flex items-center justify-center flex-shrink-0 relative">
                  <Icon
                    size={collapsed ? 20 : 18}
                    className="transition-transform duration-200"
                  />
                </div>
                <span
                  className={`text-sm font-medium transition-all duration-300 ${collapsed
                    ? "opacity-0 w-0 overflow-hidden"
                    : "opacity-100 w-auto"
                    }`}
                >
                  {label}
                </span>
              </button>
            );
          }

          return (
            <NavLink
              key={label}
              to={to}
              className={({ isActive }) =>
                `flex items-center rounded-md transition-all duration-200 whitespace-nowrap overflow-hidden group relative ${isActive
                  ? "text-white bg-slate-800"
                  : "text-slate-400 hover:bg-slate-900 hover:text-white"
                } ${collapsed
                  ? "w-10 h-10 justify-center mx-auto"
                  : "gap-3 py-2 px-3"
                }`
              }
              onClick={(e) => {
                setCollapsedPicker({ open: false, label: "", children: [], top: 0 });
                if (label === "Users") {
                  e.preventDefault();
                  const lastSearch = sessionStorage.getItem('users_last_search');
                  navigate(lastSearch ? `/users?${lastSearch}` : "/users");
                }
                if (onClick) onClick(e);
              }}
              title={collapsed ? label : ""}
            >
              <div className="flex items-center justify-center flex-shrink-0 relative">
                <Icon
                  size={collapsed ? 20 : 18}
                  className="transition-transform duration-200"
                />
                {label === "Whatsapp" && totalUnreadCount > 0 && (
                  <span
                    className={`absolute -top-1 -right-1 flex h-2.5 w-2.5 ${collapsed ? "right-0" : "-right-1"}`}
                  >
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500"></span>
                  </span>
                )}
              </div>
              <span
                className={`text-sm font-medium transition-all duration-300 ${collapsed
                  ? "opacity-0 w-0 overflow-hidden"
                  : "opacity-100 w-auto"
                  }`}
              >
                {label}
              </span>
            </NavLink>
          );
        })}
      </nav>
    </aside>
  );
}
